import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { translator } from 'mage-i18n';
import SecondaryButton from '@/components/SecondaryButton';

const BackButton = ({ t, children, dispatch, ...props }) => (
  <SecondaryButton {...props}>{children || t(`products-fe.buttons.back`)}</SecondaryButton>
);

BackButton.propTypes = {
  ...SecondaryButton.propTypes,
  children: PropTypes.node,
};

export default connect(state => ({
  t: translator(state),
}))(BackButton);
